import React from 'react';
import './ChipAssessment.scss';

const ChipAssessment = ({ text, isSelected, chipClass, selectedClass, onClick }) => {
  return (
    <div
      className={`chip ${chipClass ?? ''} ${isSelected ? (selectedClass ?? 'green-chip') : ''}`}
      onClick={onClick}>
      {text}
    </div>
  );
};

export default ChipAssessment;
